import { isPromise } from "./_internal/utils.js";
import map from "./Lazy/map.js";
import reject from "./Lazy/reject.js";
import toAsync from "./Lazy/toAsync.js";
import zip from "./Lazy/zip.js";
import pipe from "./pipe.js";
import toArray from "./toArray.js";
function omitBy(f, obj) {
    if (obj === undefined) {
        return (obj) => omitBy(f, obj);
    }
    const entries = Object.entries(obj);
    const conditions = entries.map((entry) => f(entry));
    const isAsync = conditions.some((c) => isPromise(c));
    if (isAsync) {
        return pipe(entries, zip(toAsync(conditions)), reject(([cond]) => cond), map(([, entry]) => entry), toArray, Object.fromEntries);
    }
    else {
        return pipe(entries, zip(conditions), reject(([cond]) => cond), map(([, entry]) => entry), Object.fromEntries);
    }
}
export default omitBy;
//# sourceMappingURL=omitBy.js.map